import { render, staticRenderFns } from "./OpeningHours.vue?vue&type=template&id=04e3b098&scoped=true&"
import script from "./OpeningHours.vue?vue&type=script&lang=js&"
export * from "./OpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3b098",
  null
  
)

export default component.exports